import React, { useState, useEffect } from "react";
import { ExpandedAccordion } from "../../../shared/components/ui/ExpandedAccordion";

const ParentExpandRow = ({ item, onUpdate, viewMode = "expanded" }) => {
  const [localItem, setLocalItem] = useState(item);

  useEffect(() => {
    setLocalItem(item);
  }, [item]);

  const handleChildUpdate = (updatedParent) => {
    setLocalItem(updatedParent);
    if (onUpdate) onUpdate(updatedParent);
  };

  const sections = [
    {
      id: "parent",
      title: "Parent Information",
      fields: [
        { label: "Gender", value: localItem.gender || "—" },
        {
          label: "Date of Birth",
          value: localItem.dateOfBirth
            ? new Date(localItem.dateOfBirth).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
              })
            : "—",
        },
        { label: "Blood Group", value: localItem.bloodGroup || "—" },
        {
          label: "Number of Children",
          value: Array.isArray(localItem.children) ? localItem.children.length : 0,
        },
        {
          label: "Relation with Child",
          value: localItem.relationWithChild || "—",
        },
      ],
    },
    {
      id: "contact",
      title: "Contact & Address",
      fields: [
        { label: "Phone", value: localItem.phone || "—" },
        { label: "Email", value: localItem.email || "—" },
        { label: "Address", value: localItem.address || "—", isLong: true },
        { label: "City", value: localItem.city || "—" },
        { label: "State", value: localItem.state || "—" },
        { label: "Pincode", value: localItem.pincode || "—" },
        {
          label: "Emergency Contact",
          value: localItem.emergencyContactName || "—",
        },
        { label: "Emergency Phone", value: localItem.emergencyContactPhone || "—" },
      ],
    },
    {
      id: "medical",
      title: "Medical & Notes",
      fields: [
        {
          label: "Registration Date",
          value: localItem.createdAt || "Not recorded",
        },
        {
          label: "Registration Time",
          value: localItem.registrationTime || "Not recorded",
        },
        {
          label: "Medical History",
          value: localItem.medicalHistory || "—",
          isLong: true,
        },
        { label: "Notes", value: localItem.notes || "—", isLong: true },
      ],
    },
  ];

  // ✅ Add children section for expanded view and show view (detail page)
  if ((viewMode === "expanded" || viewMode === "show") && Array.isArray(localItem.children)) {
    sections.splice(1, 0, {
      id: "children",
      title: "Children Information",
      isChildrenSection: true,
      children: localItem.children,
    });
  }

  return <ExpandedAccordion sections={sections} item={localItem} onChildUpdate={handleChildUpdate} />;
};

export default ParentExpandRow;
